import React from 'react';
import { connect } from 'react-redux';
import { TERMINATE_STATE_IMAGE } from '../config/media';
import Wrapper from './style';


const ExchangeTerminateMessage = ({constant, left}) => {

    return (
        <Wrapper>
            {constant.isExchangeExpired &&
                <div className='pop-up-content' style={{left}}>
                    <div className='container'>
                        <div className='image-container'>
                            <img src={TERMINATE_STATE_IMAGE} width="100px" alt="Desk-top-monitor" />
                        </div>
                        <div className='message-content'>
                            Exchange has been terminated due to inactivity. If assistant is required please contact support.
                        </div>
                    </div>
                </div>
            }
        </Wrapper>
    )
}

const mapStateToProps = (state) => {
	return {
		constant: state.constant,
	};
};
export default connect(mapStateToProps)(ExchangeTerminateMessage);
